
import Vue from 'vue'
import Vuex from 'vuex'
import { Get, Post,Put,Delete, Get2, Post2} from '../assets/common/js/https';
Vue.use(Vuex)

export default new Vuex.Store({
  state: { //定义基础的数据
    imgPathPC: 'https://clientcdn.yingcaiyuanfu.com/AyingcaiPC/PC/img/',
    imgPathApp: 'https://clientcdn.yingcaiyuanfu.com/AyingcaiPC/mobile/img/',
    vodPlayerJs: '//player.polyv.net/resp/vod-player-drm/canary/player.js',
    showLogin: false, // 登录弹窗
    showBind: false, // 绑定手机号弹窗
    showRegister: false, // 绑定公司姓名弹窗
    loginInfo: {
      Token: ''
    },
    userInfo: {},
    headerInfo:{
      MemberName: ''
    },
    DrawerState:false,
    mobileToken: '',
    activeAddress:{
      Id:"",
    },
    chrtNum: 0,
    UnionId: '',
    h5LivePayDialog:false,//直播支付弹窗
    h5LivePayData:{},//直播下单购买下单数据，二维码和ak
    loginQrCode: {
      ExpireSeconds: 0,
      Scene: '',
      Url: ''
    },

  },
  mutations: { 
    setLoginQrCode(state, data) {
      state.loginQrCode = data;
    },
    //设置h5商城购买弹窗所需数据
    seth5LivePayData(state,data){
      state.h5LivePayData = data;
    },
    //显示/隐藏h5商城支付弹窗
    seth5LivePayDialog(state,data){
      state.h5LivePayDialog = data;
  },
    nowAddress(state,datas){
      state.activeAddress = datas;
    },
    setChrtNum(state,datas){
      state.chrtNum = datas;
    },
    setMobileToken(state, payload) {
      state.mobileToken = payload;
    },
    changeShowLoginState(state, payload) {
      state.showLogin = payload;
    },
    changeShowBindStatus(state, payload) {
      state.showBind = payload;
    },
    changeShowRegisterStatus(state, payload) {
      state.showRegister = payload;
    },
    setLoginInfo(state, payload) {
      // console.log(state,payload)
      state.loginInfo = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setheaderInfo(state, payload) {
      state.headerInfo = payload;
    },
    setDrawerState(state, payload) {//关闭抽屉状态
      state.DrawerState = payload;
    },
    setUnionId(state, payload) {//关闭抽屉状态
      state.UnionId = payload;
    },
    
    qrCodeLogin(state,code) {
      state.showLogin = false;
      Post('Member/v2/qrcodelogin', {code}).then(res => {
        res = {
          Code: 200,
          Data: {Adviser: null,
            BindType: 1,
            CompanyName: null,
            Id: null,
            IsReg: true,
            LoginId: null,
            MemberName: null,
            Phone: null,
            Photo: null,
            ShareCode: null,
            Token: null,
            UnionId: "oeHq2007YHue0HVnbiF-o4UlbLJ0"
          },
          Msg: "请绑定手机号"
        }
        console.log(res)
        if(res){
          if(res.Data.BindType==1){ // 绑定手机号
            state.showBind = true;
            state.UnionId = res.Data.UnionId || ''
          } else if (res.Data.BindType==2) { // 绑定姓名公司名
            state.showRegister = true;
          } else {
            state.loginInfo = res.Data
            sessionStorage.setItem('loginInfo', JSON.stringify(res.Data));
            setTimeout(()=>{
              window.location.reload()
            },200)
          }
        }
      })
    },
    //绑定手机号
    bindPhone(state,data){
      data.UnionId = state.UnionId
      Post('/Member/v2/bindphone', data).then(res => {
        if(res&&res.Code==200){
          setTimeout(() => {
            state.showBind = false;
          }, 150);
          //未注册走一遍账号验证码登陆
          if(res.Data.BindType==3){
            data["UnionId"] = state.userInfo.UnionId;
            // this.commit('userlogin',data)
          } else {
            //第一次登录注册填写姓名律所
            if(res.Data.BindType==2){
              setTimeout(()=>{
                  state.showRegister = true;
                  // setToken(res.Data.Token)
                  // state.userInfo.Token = res.Data.Token
              },100)
            } else if(res.Data.BindType==0){//之前用这个手机号登陆过直接登陆成功
              state.loginInfo = res.Data
              sessionStorage.setItem('loginInfo', JSON.stringify(res.Data));
              setHeaderInfo()
              // state.Login = true;
              // setToken(res.Data.Token)
              // Message({
              //     type:"success",
              //     message:res.Msg
              // })
              // setTimeout(()=>{
              //     // state.changeReload = !state.changeReload;
              //     window.location.reload()
              // },200)
            }
          }
        }
      })
    },
    closeRegister(state) {
      state.showRegister = false;
      if(router.app._route.query.code){
          let path = router.app._route.path;
          router.push(path);
      }
    },
    openRegister(state) {
      state.showRegister = true
    },
    //填写姓名律所提交
    Registers(state,datas){
      Post('Member/v2/updatemember', datas).then(res=>{
        if(res){
          state.loginInfo = res.Data
          sessionStorage.setItem('loginInfo', JSON.stringify(res.Data));
          state.showRegister = false;
          // state.Login = true;
          Message({
            type:"success",
            message:res.Msg
          })
          // window.location.reload()
          setHeaderInfo()
        }
      })
    },

    setHeaderInfo(state) {
      Get('Member/v1/membercenter',{}).then(ress=>{
        if(ress.Code==200){
          let objs=ress.Data;
          Get('Goods/v1/addresslist',{type:0}).then(addres=>{
            if(addres.Code==200){
              objs.addresNum=addres.Data?addres.Data.length:0;
              Post('Platform/GetIntegral',{}).then(apx=>{
                if(apx.Code==200){
                  objs.Jifen=apx.Data;
                }else{
                  objs.Jifen=0;
                }
                state.headerInfo = objs;
                sessionStorage.setItem('headerInfo',JSON.stringify(objs));
                window.location.reload();
              })
            }
          })
          
        }
      })
    },
    //修改用户头像
    changeUserimg(state,data){
      let loginInfo = JSON.parse(JSON.stringify(state.loginInfo))
      loginInfo.Photo = data
      state.loginInfo = loginInfo
  },

  
  },
  actions: {
    
  },
  modules: {

  }
})





// WEBPACK FOOTER //
// ./src/store/index.js